export const ButtonStyles: React.CSSProperties = {
  margin: 0,
}
